package com.arena_web.ui.components.widgets

import androidx.compose.runtime.*
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.withAlpha
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

enum class AvatarSize(val sizePxVal: Int, val fontSizePxVal: Int) {
    XSMALL(32, 12),
    SMALL(36, 14),
    MEDIUM(40, 14),
    LARGE(56, 20),
    XLARGE(80, 28)
}

@Composable
fun Avatar(
    modifier: Modifier = Modifier,
    imageUrl: String? = null,
    name: String? = null,
    size: AvatarSize = AvatarSize.MEDIUM,
    isCircle: Boolean = true
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    val initials = name?.split(" ")
        ?.take(2)
        ?.mapNotNull { it.firstOrNull()?.uppercase() }
        ?.joinToString("") ?: "?"

    Box(
        modifier = modifier
            .sSize(size.sizePxVal)
            .then(if (isCircle) Modifier.borderRadius(50.percent) else Modifier.sBorderRadius(8))
            .backgroundColor(AppColors.Primary.withAlpha(0.2f))
            .styleModifier { property("overflow", "hidden") },
        contentAlignment = Alignment.Center
    ) {
        if (imageUrl != null) {
            Div(attrs = {
                ref { el ->
                    el.innerHTML = "<img src=\"$imageUrl\" referrerpolicy=\"no-referrer\" " +
                        "onerror=\"this.style.display='none';this.nextSibling.style.display='flex'\" " +
                        "style=\"width:100%;height:100%;object-fit:cover;\" />" +
                        "<span style=\"display:none;width:100%;height:100%;align-items:center;justify-content:center;" +
                        "font-size:${size.fontSizePxVal}px;font-weight:600;color:rgba(59,130,246,0.8);\">$initials</span>"
                    onDispose {}
                }
                style { property("width", "100%"); property("height", "100%") }
            })
        } else {
            SpanText(
                initials,
                modifier = Modifier
                    .sFontSize(size.fontSizePxVal)
                    .fontWeight(FontWeight.SemiBold)
                    .color(AppColors.Primary)
            )
        }
    }
}
